import React from "react";
import Chat from './Chat/Chat';
import Onboarding from './Onboarding/Onboarding';
import Help from './Help/Help';

const Factory = (props) => {

    const { formatador } = props.data;

    switch (Number(formatador)) {
        case 1: return <Chat {...props} />
        case 3: return <Onboarding {...props} />
        case 4: return <Help {...props} />
        default: return <React.Fragment> </React.Fragment>
    }
}



export default Factory;